<template>
	<div class="experience">
		<div class="info experienceInfo">
			<div class="experience-con">
				<div class="indexTitle">
					<p class="flexItems"><span></span>体验</p>
					<p>Experience</p>
				</div>

				<div class="phone-experience-img">
					<img src="../../static/img/ex2.jpg" alt="">
				</div>

				<div class="experience-content">
					<p>一键叫车, 一键叫船, 一键找货，</p>
					<p>一切, <span>如此简单</span></p>
					<div class="experience-ewm flex develop-history-swiper ">
					<swiper ref="mySwiper" :options="swiperOptions" style="width:450px">
					<swiper-slide>
						<div class="develop-history-slide flex develop-history-item">
							<img src="../../static/img/ewm-cd.png" alt=""/><br/>
							<p style="display:inline-block">水运船东版</p>
						</div>
						<div class="develop-history-slide flex develop-history-item">
							<img src="../../static/img/ewm-hz.png" alt=""/><br/>
							<p style="display:inline-block">水运货主版</p>
						</div>
					</swiper-slide>
						<swiper-slide>
						<div class="develop-history-slide flex develop-history-item">
							<img src="../../static/img/ewm-sj2.jpg" alt=""/><br/>
							<p style="display:inline-block">汽运司机版</p>
						</div>
						<div class="develop-history-slide flex develop-history-item">
							<img src="../../static/img/ewm-owner2.jpg" alt=""/><br/>
							<p style="display:inline-block">汽运货主版</p>
						</div>
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination" ref="briefPage"></div>
						<div class="swiper-button-top swiper-button-black" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
    					<div class="swiper-button-bottom swiper-button-black" slot="button-next"><i class="el-icon-arrow-right"></i></div>
					</swiper>
					</div>

					<div class="experience-li">
						<ul class="clearfix">
							<li>水陆多式联运数智化平台</li>
							<li>便捷的交易结算支付工具</li>
							<li>划时代的行业信用体系</li>
							<li>互联网水陆运输产业生态链</li>
						</ul>
					</div>
					<div class="clickDownLoad flexCenter" v-if="!appStatus"  @click="shipShow" style="margin-bottom:10px">
						立即下载水运
					</div>
					<div class="clickDownLoad flexCenter" v-if="!appStatusIos" @click="truckShow" style="margin-bottom:10px">
						立即下载汽运
					</div>
					<div class="downloadApp" v-if="appStatus">
						<div class="flexCenter">
							<img src="../../static/img/android.svg" width="17" alt="">
							<span>安卓端船东版</span>
						</div>
						<div class="flexCenter">
							<img src="../../static/img/android.svg" width="17" alt="">
							<span>安卓端货主版</span>
						</div>
						<div class="flexCenter">
							<img src="../../static/img/iphone.svg" width="16" alt="">
							<span>苹果端船东版</span>
						</div>
						<div class="flexCenter">
							<img src="../../static/img/iphone.svg" width="16" alt="">
							<span>苹果端货主版</span>
						</div>
					</div>
					<div class="downloadApp" v-if="appStatusIos">
						<div class="flexCenter">
							<img src="../../static/img/android.svg" width="17" alt="">
							<span>安卓端司机版</span>
						</div>
						<div class="flexCenter">
							<img src="../../static/img/android.svg" width="17" alt="">
							<span>安卓端货主版</span>
						</div>
						<div class="flexCenter">
							<img src="../../static/img/iphone.svg" width="16" alt="">
							<span>苹果端司机版</span>
						</div>
						<div class="flexCenter">
							<img src="../../static/img/iphone.svg" width="16" alt="">
							<span>苹果端货主版</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<span class="zmldown2"></span>
	</div>
</template>
<script>
  export default{
    data(){
      return{
		appStatus: false,
		appStatusIos: false,
		swiperOptions: {
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				autoplay: {
					delay: 6000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				navigation: {
					nextEl: '.swiper-button-bottom',
					prevEl: '.swiper-button-top'
				}
				// spaceBetween : 120,
			}
      }
	},
	methods: {
		shipShow() {
			this.appStatusIos = false
			this.appStatus = true
		},
		truckShow() {
			this.appStatus = false
			this.appStatusIos = true
	}
	},
  }
</script>
<style scoped="scoped">
/* 体验下载 */
.experience{
	width: 100%;
	height:100%;
	background: url(../../static/img/ex2.jpg) no-repeat right 98%;
	background-size: 45%;
	background-color: #fff;
}
.experience-con{
	padding-top: 110px;
}
.experience-content{
	padding-left: 86px;
	padding-top: 110px;
}
.experience-content>p:nth-of-type(1){
	font-size: 30px;
	color: #282828;
}
.experience-content>p:nth-of-type(2){
	font-size: 64px;
	color: #282828;
	margin: 5px 0;
}
.experience-content>p:nth-of-type(2) span{
	color: #127BFD;
}
.experience-ewm{
	color: #787878;
	text-align: center;
	padding: 10px 0;
	margin-left: -890px;
	/* margin-left: -950px; */
	/* left: -100px; */
}
.experience-ewm img{
	display: inline-block;
	width: 160px;
	box-shadow: 0 5px 10px 0 rgba(0,0,0,.1);
	margin-right: 1px;
}
.experience-ewm p{
	margin-top: 10px;
}
.experience-li{
	max-width: 505px;
}
.experience-li ul li{
	float: left;
	width: 50%;
	list-style: disc;
	color: #282828;
	font-size: 18px;
	margin: 8px 0;
}
.experience-li ul li:nth-of-type(even){
	float: right;
}

.clickDownLoad{
	display: none;
	width: 130px;
	height: 28px;
	background:rgba(18,123,253,1);
	border-radius:26px;
	color: #FFFFFF;
	font-size: 12px;
	margin: auto;
}
.phone-experience-img{
	width: 100%;
	height: auto;
	background-color: #EFEFEF;
	display: none;
	padding: 26px 13px 0 13px;
	margin-bottom: 20px;
}
.phone-experience-img img{
	width: 100%;
}

.downloadApp{
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
}
.downloadApp>div{
	width: 130px;
	height: 28px;
	border:1px solid rgba(204,204,204,1);
	border-radius:28px;
	font-size: 12px;
	color: #454545;
	margin: 0 10px 10px 10px;
}
.downloadApp img{
	margin-right: 10px;
}
.develop-history-slide {
	justify-content: space-between;
}
.develop-history-item {
	display: inline-block;
	overflow: hidden;
	height: auto;
	/* margin-right: 183px; */
	margin: 0 10px;
}
.swiper-button-top,
.swiper-button-bottom {
    position: absolute;
    top: 26%;
    width: 80px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: center;
	background-repeat: no-repeat;
	font-size: 60px;
}
.swiper-button-top{
	margin-left: -24px;
}
.swiper-button-bottom{
	margin-left: 390px;
}
@media only screen and (max-width: 1400px){
	.experience-li{
		max-width: 100%;
	}
	.experience-li ul li{
		margin-left: 25px;
		width: 35%;
	}
	.experience-li ul li:nth-of-type(even){
		float: left;
	}
}
@media only screen and (max-width: 1600px){
	.experience{
		background-size: 50%;
	}
	.experience-con{
		height: 100%;
		display: flex;
		flex-flow: column;
		justify-content: space-around;
	}
	.experience-content{
		padding: 30px 0;
	}
	.experienceInfo{
		/* width: 80%;
		margin-left: 0; */
	}
	.experience-ewm{
		margin-left: -960px;
	}
}

@media only screen and (max-width: 750px){
	.swiper-pagination{
		top: 130px;
	}
	.swiper-button-top,
	.swiper-button-bottom {
		display: none;
	}
	.experience{
		background: url();
	}
	.experienceInfo{
		padding: 0;
	}
	.experience-con{
		padding-top: 0;
		justify-content: start;
	}
	.experience-content{
		padding: 0;
		text-align: center;
		flex: 1;
		display: flex;
		flex-flow: column;
		justify-content: center;
	}
	.experience-ewm{
		display: flex;
		justify-content: center;
		font-size: 12px;
		margin-top: -20px;
		margin-left: 0px;
	}
	.experience-ewm img{
		display: inline-block;
		width: 111px;
		margin-right: 0;
	}
	.experience-ewm>div{
		margin: 0 20px;
	}
	.experience-ewm-truck{
		display: flex;
		justify-content: center;
		font-size: 12px;
		margin-top: -10px;
	}
	.experience-ewm-truck img{
		width: 111px;
		margin-right: 0;
	}
	.experience-ewm-truck>div{
		margin: 0 20px;
	}
	.experience-li{
		display: none;
	}
	.clickDownLoad{
		display: flex;
		margin: 0 auto;
		/* margin: 0; */
	}
	.phone-experience-img{
		display: block;
		margin-bottom: 0;
	}
	.indexTitle{
		position: absolute;
		top: 0;
	}
	.experience-content>p:nth-of-type(1){
		font-size: 20px;
		font-weight: bold;
	}
	.experience-content>p:nth-of-type(2){
		font-size: 40px;
		font-weight: bold;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/index_experience.vue